<section class="q-section-carousel" style="padding-top:0;padding-bottom:0;z-index: 1;">
  <carousel height="600" cellWidth="100%">
    <div class="jumbotron carousel-cell"></div>
    <div class="jumbotron jumbotron--smart_industry carousel-cell">
      <div class="container">
        <div class="jumbotron-content text-white">
          <h1 class="font-weight-bolder mt-5">{{'main.jumbotron_title' | translate}}</h1>
          <p class="lead">{{'main.jumbotron_subtitle' | translate}}</p>
        </div>
      </div>
    </div>
  </carousel>
</section>
<style>
  .text-estadistica {
    font-size: 30px;
    font-weight: bold;
    text-align: left;
  }

  .color-green {
    font-size: 40px;
    color: #7FB035 !important
  }

  .gap-indicadores {
    gap: 10px;
  }

  @media (min-width: 1200px) {
    .parrafo-descripcion {
      max-width: 488px;
    }
  }
</style>
<section class="py-5" style="background-color: #F5F7FA;">
  <div class="container d-flex flex-column flex-md-row justify-content-between gap-indicadores">
    <div class="mb-md-0 w-100 w-lg-50">
      <div>
        <h4 class="fw-bold"><span style="color: #4D4D4D;
          font-size: 25px;
          font-weight: bold;">Contribuyendo a un</span><br><span class="highlight color-green"><b>aire más
              limpio</b></span></h4>
        <p class="text-muted parrafo-descripcion">Nuestra experiencia y compromiso nos ha permitido impactar en múltiples regiones.</p>
      </div>
    </div>
    <div class="row text-center text-md-start w-100 w-lg-50">
      <div class="col-6 col-md-6 mb-4">
        <div class="d-flex align-items-center">
          <img src="../../../assets/img/INICIO/icono-cliente.png" alt="Clientes satisfechos">
          <div class="ml-3">
            <h6 class="fw-bold mb-0 text-estadistica">100+</h6>
            <small class="text-muted">Clientes satisfechos</small>
          </div>
        </div>
      </div>
      <div class="col-6 col-md-6 mb-4">
        <div class="d-flex align-items-center">
          <img src="../../../assets/img/INICIO/icono-experiencia.png" alt="Años de experiencia">
          <div class="ml-3">
            <h6 class="fw-bold mb-0 text-estadistica">09+</h6>
            <small class="text-muted">Años de experiencia</small>
          </div>
        </div>
      </div>
      <div class="col-6 col-md-6 mb-4">
        <div class="d-flex align-items-center">
          <img src="../../../assets/img/INICIO/icono-modulos.png" alt="Estaciones instaladas">
          <div class="ml-3">
            <h6 class="fw-bold mb-0 text-estadistica">50+</h6>
            <small class="text-muted">Estaciones instaladas</small>
          </div>
        </div>
      </div>
      <div class="col-6 col-md-6 mb-4">
        <div class="d-flex align-items-center">
          <img src="../../../assets/img/INICIO/icono-personas.png" alt="Personas beneficiadas">
          <div class="ml-3">
            <h6 class="fw-bold mb-0 text-estadistica">500+</h6>
            <small class="text-muted">Personas beneficiadas</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- <section class="section-2">
 
      <div class="content">
          <h1 class="font-weight-bolder">Software qAIRamap</h1>
          <p class="py-0">
            {{'app.software_qairamap_sub' | translate}}
          </p>
          <img src="../../../assets/img/INICIO/laptop-y-celular-qairamap.png" alt="">
          <img style="width: 15% !important;" src="../../../assets/img/INICIO/celular.png" alt="">
          <img style="width: 50% !important;" src="../../../assets/img/INICIO/OKR0RO1.png" alt=""> 
          <br>
          <a  [routerLink]="['/solucion/ambiental']" class="btn custom-cta" >{{'app.see_more' | translate}}</a>
          <a  href="https://qairamap.qairadrones.com/" class="btn custom-cta ml-5 bg-yellow-qaira" target="_blank">qAIRamap</a>
      </div>
 
</section> -->
<section class="bg-green-qaira">
  <div class="container py-3 text-white">
    <div class="row">
      <!-- <div class="col-lg-3" style=" text-align: center; margin: auto;">
        <p class="lead">{{'app.software_qairamap_sub1' | translate}}</p>
        <a  href="https://qairamap.qairadrones.com/" class="btn custom-cta bg-yellow-qaira" target="_blank">{{'app.click_here' | translate}}</a>
      </div> -->
      <div class="col-lg-12" style=" text-align: center;">
        <h2 class="q-section__title font-weight-bolder">Software qAIRamap</h2>
        <p class="py-0">
          {{'app.software_qairamap_sub' | translate}}
        </p>
        <a target="_blank" href="https://qairamap.qairadrones.com/" class="btn custom-cta custom-cta--padding bg-yellow-qaira">{{'app.view_qhairamap' | translate}}</a>
        <a [routerLink]="['/solucion/ambiental']" class="btn custom-cta custom-cta--padding">{{'app.see_more' |
          translate}}</a>
        <img style="width: 100%;" src="../../../assets/img/INICIO/laptop-y-celular-qairamap.png" alt="">
        <!-- <div class="row" style=" justify-content: center;align-items: center;">
          <p class="lead">{{'app.software_qairamap_sub1' | translate}}</p>

          <a href="https://qairamap.qairadrones.com/" class="btn custom-cta bg-yellow-qaira" target="_blank"
            style="display:block; height: 5em; width: 5em; border-radius: 50%;margin: 0.1em 5em;padding-top: 1em;">{{'app.click_here'
            | translate}}</a>
        </div> -->
      </div>
    </div>
  </div>
</section>

<section class="section-3">
  <div class="container py-3">
    <div class="row">
      <div class="col-lg-12 text-center q-section--title">
        <h2 class="q-section__title font-weight-bolder text-green-qaira">Módulos de la calidad del aire</h2>
        <p class="py-0">
          {{'app.software_qairamap_sub' | translate}}
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 q-module">
        <div class="text-center q-box-mod">
          <h3 class="font-weight-bolder">qHAWAX</h3>
          <p>{{'qhawax.subtitle' | translate}}</p>
          <picture class="e-lazy__img e-lazy__img">
            <source data-srcset=" ../../../assets/img/INICIO/q-qhawax_ext.png  1x, ../../../assets/img/INICIO/q-qhawax_ext@2x.png  2x" type="image/png" srcset=" ../../../assets/img/INICIO/q-qhawax_ext.png  1x, ../../../assets/img/INICIO/q-qhawax_ext@2x.png  2x">
            <img class="e-lazy-js loaded" data-src=" ../../../assets/img/INICIO/q-qhawax_ext.png " src="../../../assets/img/INICIO/q-qhawax_ext.png " data-ll-status="loaded">
          </picture>
        </div>
        <div>
          <div class="">
            <div class="row">
              <div class="col-lg-12 padding-block-description">
                <div class="card">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-2 text-center">
                        <img style="width: 35px;" src="../../../assets/img/icons/Seccion Inicio/qHAWAX/qhawax-exteior-01.png" alt="">
                      </div>
                      <div class="col-10 text-sm">
                        <span><b>{{'qhawax.led_title' | translate}}</b></span>
                        <p>{{'qhawax.led_text' | translate}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-4">
              <div class="col-lg-6 padding-block-description">
                <div class="card">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-2 text-center">
                        <img style="width: 35px;" src="../../../assets/img/icons/Seccion Inicio/qHAWAX/qhawax-exteior-02.png" alt="">
                      </div>
                      <div class="col-10 text-sm">
                        <span><b>{{'qhawax.telemetry' | translate}}</b></span>
                        <p>{{'qhawax.telemetry_text' | translate}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 padding-block-description">
                <div class="card">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-2 text-center">
                        <img style="width: 35px;" src="../../../assets/img/icons/Seccion Inicio/qHAWAX/qhawax-exteior-03.png" alt="">
                      </div>
                      <div class="col-10 text-sm">
                        <span><b>{{'qhawax.power' | translate}}</b></span>
                        <p>{{'qhawax.power_text' | translate}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-center mb-4">
              <a [routerLink]="['/solucion/ambiental']" class="btn custom-cta bg-yellow-qaira custom-cta--padding">{{'app.see_more' |
                translate}}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 q-module">
        <div class="q-box-mod text-center">
          <h3 class="font-weight-bolder text-green-qaira">qHAWAX-in</h3>
          <p>{{'qhawax.subtitle_in' | translate}}</p>
          <picture class="q-qhawax-interior">
            <source data-srcset=" ../../../assets/img/INICIO/q-qhawax_int.png  1x, ../../../assets/img/INICIO/q-qhawax_int@2x.png  2x" type="image/png" srcset=" ../../../assets/img/INICIO/q-qhawax_int.png  1x, ../../../assets/img/INICIO/q-qhawax_int@2x.png  2x">
            <img class="e-lazy-js loaded" data-src=" ../../../assets/img/INICIO/q-qhawax_int.png " src="../../../assets/img/INICIO/q-qhawax_int.png " data-ll-status="loaded">
          </picture>
        </div>
        <div>
          <div class="">

            <div class="row">
              <div class="col-lg-12 padding-block-description">
                <div class="card">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-2 text-center">
                        <img style="width: 35px;" src="../../../assets/img/icons/Seccion Inicio/qHAWAX/qhawax-interior-01.png" alt="">
                      </div>
                      <div class="col-10 text-sm">
                        <span><b>{{'qhawax.led_title' | translate}}</b></span>
                        <p>{{'qhawax.led_text_in' | translate}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-4">
              <div class="col-lg-6 padding-block-description">
                <div class="card">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-2 text-center">
                        <img style="width: 35px;" src="../../../assets/img/icons/Seccion Inicio/qHAWAX/qhawax-interior-02.png" alt="">
                      </div>
                      <div class="col-10 text-sm">
                        <span><b>{{'qhawax.telemetry' | translate}}</b></span>
                        <p>{{'qhawax.telemetry_text_in' | translate}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 padding-block-description">
                <div class="card">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-2 text-center">
                        <img style="width: 35px;" src="../../../assets/img/icons/Seccion Inicio/qHAWAX/qhawax-interior-03.png" alt="">
                      </div>
                      <div class="col-10 text-sm">
                        <span><b>{{'qhawax.power' | translate}}</b></span>
                        <p>{{'qhawax.power_text_in' | translate}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-center">
              <a [routerLink]="['/solucion/ambiental']" class="btn custom-cta bg-yellow-qaira custom-cta--padding">{{'app.see_more' |
                translate}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="bg-green-qaira">
  <div class="container text-center text-white">
    <h2 class="font-weight-bolder q-section__title">{{'video.title' | translate}}</h2>
    <p>{{'video.subtitle' | translate}}</p>
    <div class="row py-4">
      <div class="col-lg-9">
        <iframe class="video" src="https://www.youtube.com/embed/0YqGAWmsv-U" frameborder="0"></iframe>
      </div>
      <div class="col-lg-3">
        <div class="content-video pb-2">
          <iframe class="video_sub" src="https://www.youtube.com/embed/88KMhjf9X1A" frameborder="0"></iframe>
        </div>
        <div class="content-video pb-2">
          <iframe class="video_sub" src="https://www.youtube.com/embed/6voOntg5wJQ" frameborder="0"></iframe>
        </div>
        <div class="content-video pb-2">
          <iframe class="video_sub" src="https://www.youtube.com/embed/l04ZWun10Os" frameborder="0"></iframe>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="testimonial text-center testimonial-web">
  <div class="heading white-heading">
    Testimonios
  </div>
  <carousel [cellsToShow]="slidesToShow" class="owl-carousel is-myc mt-5" [dots]="true" transitionTimingFunction="ease-in-out" loop="true" autoplayInterval="15000" autoplay="true">
    <div class="carousel-cell" *ngFor="let item of listTestimonios">
      <div class="testimonial4_slide">
        <img [src]="item.url_imagen" class="img-circle img-responsive" />
        <h3>{{item.empresa}}</h3>
        <p>"{{item.comentario}}"</p>
        <h4><b>{{item.autor}}</b>{{item.cargo}}</h4>
      </div>
    </div>
  </carousel>
</section>
<!-- <div class="container mt-5 mb-5">
  <div class="row">
    <div class="col-lg-12 text-center q-news__title" style="margin-bottom:0">
      <h2 class="q-section__title font-weight-bolder text-green-qaira">Testimonios</h2>
      <p class="py-0">Descubre cómo hemos transformado la experiencia de nuestros clientes.</p>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <carousel [cellsToShow]="slidesToShow" class="owl-carousel is-myc mt-5" [dots]="true" overflowCellsLimit="1"
        transitionTimingFunction="ease-in-out" loop="true" autoplayInterval="2000">
        <div class="carousel-cell" *ngFor="let item of listTestimonios">
          <div class="testimonial" id="item_{{item.id}}">
            <div class="pic">
              <img [src]="item.url_imagen">
            </div>
            <p class="description">{{item.comentario}}</p>
            <h3 class="title">{{item.autor}}</h3>
            <small class="post"> {{item.cargo}}</small>
          </div>
        </div>
      </carousel>
    </div>
  </div>
</div> -->
<!-- <section class="bg-white">
  <div class="container py-1"></div>
</section> -->
<section class="section-inacal">
  <div class="container text-center">
    <div class="row">
      <div class="col-lg-12 text-center q-news__title" style="margin-bottom:0">
        <h2 class="q-section__title font-weight-bolder text-green-qaira">{{'header.inacaltitle' | translate}}</h2>
        <p>{{'header.inacalsubtitle' | translate}}</p>
      </div>
    </div>
    <section>
      <div class="container py-4 text-left">
        <div class="section-inacal--content">
          <div class="">
            <picture>
              <source srcset="../../../assets/img/INICIO/logo_inacal_v1.png, ../../../assets/img/INICIO/logo_inacal_v1@2x.png 2x" media="(min-width: 1024px)" type="image/png">
              <img src="../../../assets/img/INICIO/logo_inacal_v1@2x.png" alt="Mapa lidar qaira">
            </picture>
          </div>
          <div class="">
            <p class="py-0">{{'header.inacaldesc_1' | translate}}</p>
            <p class="py-0">{{'header.inacaldesc_2' | translate}} <a href="https://www.gob.pe/institucion/inacal/noticias/1179732-inacal-desarrollara-nuevas-normas-tecnicas-para-productos-tecnologicos-emergentes-e-innovadores" target="_blank">{{'app.click_here' | translate}}</a></p>
          </div>
        </div>
      </div>
    </section>

  </div>
</section>
<section class="section-blog">
  <div class="container text-center">
    <div class="row">
      <div class="col-lg-12 text-center q-news__title" style="margin-bottom:0">
        <h2 class="q-section__title font-weight-bolder text-green-qaira">{{'blog.blogtitle' | translate}}</h2>
        <p class="py-0">{{'blog.subtitle' | translate}}</p>
      </div>
    </div>
    <section>
      <div class="container py-4 text-center">
        <div class="row content-blog is-flex justify-content-center">
          <div class="col-lg-4" *ngFor="let item of listBlogs">
            <app-blog-item [blog]="item" [viewBtn]="false"></app-blog-item>
          </div>
        </div>
      </div>
    </section>

  </div>
</section>
<section class="q-mapa-lidar">
  <!-- <h2 class="q-section__title font-weight-bolder text-green-qaira">Nuestra presencia en el Perú</h2>
  <p>Innovación y tecnología a tu servicio</p> -->
  <picture>
    <source srcset="../../../assets/img/INICIO/mapa_servicios.png, ../../../assets/img/INICIO/mapa_servicios@2x.png 2x" media="(min-width: 768px)" type="image/png">
    <img src="../../../assets/img/INICIO/mapa_servicios_mob@2x.png" alt="Mapa lidar qaira">
  </picture>
</section>
<section class="section-land">
  <div class="container text-center text-white">
    <h1 class="font-weight-bolder mb-5 mt-5">{{'contact_home.title' | translate}}</h1>
    <p class="mb-5">{{'contact_home.subtitle' | translate}}</p>
    <a [routerLink]="['/contacto']" class="btn custom-cta mb-5 custom-cta--padding">{{'app.contact_us' | translate}}</a>
  </div>
</section>
<!-- <section class="section-3">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 text-center q-news__title">
        <h2 class="q-section__title font-weight-bolder text-green-qaira">{{'blog.blogtitle' | translate}}</h2>
        <p class="py-0">{{'blog.subtitle' | translate}}</p>
      </div>
    </div>
    <div class="q-card__container">
      <div *ngFor="let item of listBlogs">
        <app-blog-item [blog]="item" [viewBtn]="false"></app-blog-item>
      </div> -->

<!-- <div class="q-card__news">
        <div class="q-card__news__image">
          <img decoding="async" width="938" height="549"
            src="https://getwid.getmotopress.com/wp-content/uploads/2019/04/blog2-938x549.jpg" alt="Noticias" srcset="">
        </div>
        <div class="q-card__news__title">“qAIRa”: un robot que monitorea el aire en Lima en tiempo real sin que lo sepas
        </div>
        <div class="q-card__news__resumen">La startup peruana qAIRa, liderada por Mónica Abarca, propone una solución
          innovadora para monitorear la calidad del aire...</div>
      </div>
      <div class="q-card__news">
        <div class="q-card__news__image">
          <img decoding="async" width="938" height="549"
            src="https://getwid.getmotopress.com/wp-content/uploads/2019/04/blog2-938x549.jpg" alt="Noticias" srcset="">
        </div>
        <div class="q-card__news__title">“qAIRa”: un robot que monitorea el aire en Lima en tiempo real sin que lo sepas
        </div>
        <div class="q-card__news__resumen">La startup peruana qAIRa, liderada por Mónica Abarca, propone una solución
          innovadora para monitorear la calidad del aire...</div>
      </div>
      <div class="q-card__news">
        <div class="q-card__news__image">
          <img decoding="async" width="938" height="549"
            src="https://getwid.getmotopress.com/wp-content/uploads/2019/04/blog2-938x549.jpg" alt="Noticias" srcset="">
        </div>
        <div class="q-card__news__title">“qAIRa”: un robot que monitorea el aire en Lima en tiempo real sin que lo sepas
        </div>
        <div class="q-card__news__resumen">La startup peruana qAIRa, liderada por Mónica Abarca, propone una solución
          innovadora para monitorear la calidad del aire...</div>
      </div>
    </div>
  </div>
</section> -->